<h1>Pago de Facturas</h1>

<div *ngIf="!result && !result_order" class="card mt-8">
   <h3 class="text-lg font-semibold border-b flex flex-row items-bottom">
      Consulta de contribuyente
      <img src="assets/logos/logo_{{ayuntamiento}}.png" class="ml-2 mt-1 h-6">
   </h3>
   
   <!-- Original Tabs -->
   <div class="tabs mb-4">
      <div (click)="mode = 1" class="tab" [class.active]="mode === 1">Facturas</div>
      <div (click)="mode = 2" class="tab" [class.active]="mode === 2">Ordenes de pago</div>
   </div>

   <!-- Mode 1: Facturas -->
   <div *ngIf="mode === 1">
      <!-- 1. Original Direct Search on Top -->
      <div class="flex flex-col items-stretch flex-wrap mt-6 md:flex-row md:items-baseline">
         <div class="mr-4 font-semibold">Cédula, RNC o Suscripción:</div>
         <div class="flex-grow">
            <input id="document" [(ngModel)]="filter" (keydown.enter)="query('direct')"
               placeholder="Ingrese la cédula, o el RNC que desea pagar"
               class="py-2 px-2 md:py-0 w-full rounded border-0 border-b border-gray-300">
         </div>
      </div>
      <div class="mt-4 flex flex-col md:flex-row md:gap-2 items-center">
         <button (click)="query('direct')" [disabled]="working.main || !filter?.trim()" class="w-full btn btn-blue md:w-max">
            Consultar
            <fa-icon icon="search"></fa-icon>
            <working *ngIf="working.main"></working>
         </button>
      </div>

      <!-- 2. Integrated Route/Zone Search (Replaces old Offline/Filter section) -->
      <!-- Only appears if we have cities loaded (Online or Offline from cache) -->
      <div *ngIf="cities?.length" class="mt-8 border-t pt-6">
         <h4 class="font-semibold text-gray-600 mb-3 flex items-center">
            <fa-icon icon="map-marked-alt" class="mr-2"></fa-icon>
            Búsqueda por Ruta / Cobro Móvil
            <span *ngIf="!is_online" class="ml-2 text-xs font-bold bg-red-600 text-white px-2 py-0.5 rounded-full uppercase tracking-wider">
               Offline
            </span>
         </h4>
         
         <div class="flex flex-col md:flex-row md:items-end gap-4 bg-gray-50 p-4 rounded-lg border">
            <!-- Filter: Subscription Type -->
            <div class="flex flex-col w-full md:w-1/4">
               <label class="text-sm font-semibold text-gray-500 mb-1">Tipo:</label>
               <select [(ngModel)]="search_type" class="py-2 px-3 rounded border-gray-300 w-full">
                   <option value="monthly">Mensual</option>
                   <option value="standard">Otras (Estándar)</option>
               </select>
            </div>

            <!-- Filter: Zone -->
            <div class="flex flex-col w-full md:w-1/3">
               <label class="text-sm font-semibold text-gray-500 mb-1">Zona:</label>
               <select [(ngModel)]="filter_zone" class="py-2 px-3 rounded border-gray-300 w-full">
                  <option [ngValue]="null">-- Seleccionar Zona --</option>
                  <option *ngFor="let city of cities" [value]="city.city_id">{{ city.city_name }}</option>
               </select>
            </div>

            <!-- Filter: Day (Conditional) -->
            <div class="flex flex-col w-full md:w-1/4" *ngIf="search_type === 'monthly'">
               <label class="text-sm font-semibold text-gray-500 mb-1">Día (1-31):</label>
               <input type="number" [(ngModel)]="filter_day" min="1" max="31" class="py-2 px-3 rounded border-gray-300 w-full">
            </div>

             <!-- Search Button -->
             <div class="flex flex-col w-full md:w-auto">
                 <button (click)="query('route')" 
                     [disabled]="working.main || !filter_zone || (search_type === 'monthly' && !filter_day)" 
                     class="btn btn-blue h-10">
                    <fa-icon icon="search"></fa-icon> Buscar
                 </button>
             </div>
         </div>

         <!-- Route Results List -->
         <div *ngIf="contracts_list.length > 0" class="mt-6">
            <div class="flex justify-between items-center mb-3">
               <h5 class="font-medium text-gray-700">
                  Resultados: {{ contracts_list.length }}
               </h5>
               
               <!-- Download Button (Only Online) -->
               <button *ngIf="is_online" (click)="download_current_list()" 
                       [disabled]="working.download"
                       class="btn btn-sm border-blue-600 text-blue-600 hover:bg-blue-50">
                  <fa-icon icon="cloud-download-alt" class="mr-1"></fa-icon>
                  {{ working.download ? 'Descargando...' : 'Descargar para Offline' }}
               </button>
            </div>

            <div class="space-y-2 max-h-96 overflow-y-auto">
               <div *ngFor="let contract of contracts_list" (click)="select_contract(contract)"
                  class="flex flex-col md:flex-row md:items-baseline border rounded-lg p-3 cursor-pointer shadow-sm hover:bg-gray-100 hover:shadow-md transition-all bg-white">
                  
                  <div class="flex-1 font-semibold text-blue-900 md:text-gray-800">
                     {{ contract.subscription_number }}
                  </div>
                  <div class="flex-[2] text-gray-700 font-medium md:font-normal">
                     {{ contract.name }}
                     <span class="text-xs text-gray-400 font-normal ml-1">{{ contract.document }}</span>
                  </div>
                  <div class="text-sm text-gray-500 md:flex-1 md:text-right">
                     {{ contract.address }}
                  </div>
                  <div class="font-semibold md:font-normal md:flex-1 md:text-right" 
                     [class.text-red-700]="contract.total_debt > 0" [class.text-green-700]="contract.total_debt <= 0">
                     {{ contract.total_debt | currency:'RD$ ' }}
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!-- Mode 2: Ordenes de Pago (Unchanged) -->
   <div *ngIf="mode === 2">
      <div class="flex flex-col items-stretch flex-wrap mt-6 md:flex-row md:items-baseline">
         <div class="mr-4 font-semibold">Referencia:</div>
         <div class="flex-grow">
            <input [(ngModel)]="filter" (keydown.enter)="query('direct')"
               placeholder="Ingrese el código o el ID de la orden de pago"
               class="py-2 px-2 md:py-0 w-full rounded border-0 border-b border-gray-300">
         </div>
      </div>
      <div class="mt-8 md:mt-3 flex flex-col md:flex-row md:gap-2 items-center">
         <button (click)="query('direct')" [disabled]="working.main || !filter?.trim()" class="w-full btn btn-blue md:w-max">
            Consultar Orden
            <fa-icon icon="search"></fa-icon>
            <working *ngIf="working.main"></working>
         </button>
         <button routerLink="/cashier/orders/create" [queryParams]="{ invoicer_id: 4 }" class="w-full btn md:w-max">
            <fa-icon icon="plus-circle"></fa-icon>
            Crear orden
         </button>
      </div>
   </div>
</div>

<!-- Results Views (Restored Original Design) -->
<div *ngIf="result" class="card mt-8">
   <h3 class="font-semibold border-b">
      Respuesta de consulta de contribuyente
      <img src="assets/logos/logo_{{ayuntamiento}}.png" class="inline h-4 ml-1">
   </h3>
   <div class="mt-6 flex flex-col items-stretch space-y-2">
      <div *ngIf="result.subscription_number" class="flex flex-col md:flex-row md:flex-wrap md:items-baseline">
         <div class="md:font-semibold w-52">Suscripción:</div>
         <div class="font-semibold md:font-normal md:ml-4">{{ result.subscription_number }}</div>
      </div>
      <div class="flex flex-col md:flex-row md:flex-wrap md:items-baseline">
         <div class="md:font-semibold w-52">Documento de identificación:</div>
         <div class="font-semibold md:font-normal md:ml-4">{{ result.document }}</div>
      </div>
      <div class="flex flex-col md:flex-row md:flex-wrap md:items-baseline">
         <div class="md:font-semibold w-52">Nombre del contribuyente:</div>
         <div class="font-semibold md:font-normal text-2xl md:ml-4">{{ result.name }}</div>
      </div>
      <div class="flex flex-col md:flex-row md:flex-wrap md:items-baseline">
         <div class="md:font-semibold w-52">Dirección:</div>
         <div class="font-semibold md:font-normal md:ml-4">{{ result.address }}</div>
      </div>
      <div class="flex flex-col md:flex-row md:flex-wrap md:items-baseline">
         <div class="md:font-semibold w-52">Balance:</div>
         <div class="font-semibold md:font-normal text-2xl md:ml-4">{{ result.total_debt | currency }}</div>
      </div>
      <div class="pt-4 border-t md:hidden" style="margin-top: 24px;">
         <h3 class="font-semibold">Facturas:</h3>
      </div>
      
      <!-- Original Table Layout Restored -->
      <div *ngIf="result.pending_invoices?.length > 0 || result.total_debt == 0" class="w-full md:table md:border md:rounded-md" style="margin-top: 1.5rem;">
         <div class="hidden md:block md:table-header-group">
            <div class="table-cell"></div>
            <div class="table-cell border-l" title="Número de Factura">Nro. Factura</div>
            <div class="table-cell border-l">Concepto</div>
            <div class="table-cell border-l">Fecha</div>
            <div class="table-cell border-l">Monto</div>
            <div *ngIf="partial_payments" class="table-cell border-l">Monto a pagar</div>
         </div>
         <div class="md:table-row-group">
            <div *ngIf="!result.pending_invoices?.length" class="md:table-row">
               <td title="No existen facturas pendientes para este contribuyente" class="border-t text-center"
                  colspan="6">
                  <fa-icon icon="times"></fa-icon>
               </td>
            </div>
            <div *ngFor="let invoice of result.pending_invoices"
               class="flex flex-row rounded-md mb-6 shadow md:shadow-none md:table-row">
               <div class="flex-none self-stretch pr-2 md:px-2 md:table-cell md:text-center"
                  style="border-left-width: 0;">
                  <input [(ngModel)]="selectable(invoice).selected" type="checkbox"
                     class="h-full rounded-l-md rounded-r-none md:h-auto md:rounded">
               </div>
               <div class="flex-1 md:contents">
                  <div (click)="selectable(invoice).selected = !selectable(invoice).selected"
                     class="flex flex-row md:cursor-pointer md:contents">
                     <div class="flex-1 md:border-l md:contents">
                        <div class=" md:table-cell md:px-3 md:text-right">{{ invoice.id }}</div>
                        <div class=" md:table-cell md:px-3">{{ invoice.concept }}</div>
                     </div>
                     <div class="pr-1 md:border-l md:contents">
                        <div class="text-right md:table-cell md:px-3 md:text-center">{{ invoice.issue_date | date }}
                        </div>
                        <div class="text-right md:table-cell md:px-3">{{ invoice.amount | currency:'RD$ ' }}</div>
                     </div>
                  </div>
                  <div *ngIf="partial_payments"
                     class="flex flex-row items-baseline border-t mt-1 md:table-cell md:px-2 md:text-right">
                     <div class="block min-w-max mr-1 md:hidden">Monto a pagar: RD$</div>
                     <input type="number" [(ngModel)]="selectable(invoice).amount_to_pay" [min]="0"
                        [max]="invoice.amount"
                        class="py-2 px-2 border-0 border-b boder-gray-300 w-full text-right rounded-br-md md:py-1 md:bg-gray-100 md:rounded-md">
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="flex flex-row mt-3 md:w-max">
      <button (click)="result = null" class="btn w-max mr-2">
         <fa-icon icon="arrow-left"></fa-icon>
         Volver
      </button>
      <button (click)="pay()" [disabled]="!can_pay" class="btn btn-blue flex-1">
         Pagar
         <fa-icon icon="hand-holding-usd"></fa-icon>
      </button>
   </div>
</div>

<div *ngIf="result_order" class="card mt-8">
   <!-- Existing Order Result Block (kept as original) -->
   <h3 class="font-semibold border-b">
      Respuesta de consulta de orden de pago
      <img src="assets/logos/logo_{{ayuntamiento}}.png" class="inline h-4 ml-1">
   </h3>
   <!-- (Assuming Order details HTML remains the same as provided in prompt) -->
   <div class="flex flex-row mt-3 md:w-max">
      <button (click)="result_order = null" class="btn w-max mr-2">
         <fa-icon icon="arrow-left"></fa-icon>
         Volver
      </button>
      <button (click)="pay()" [disabled]="!result_order.pending" class="btn btn-blue flex-1">
         {{ result_order.pending? 'Pagar' : '(Pagada)' }}
         <fa-icon icon="hand-holding-usd"></fa-icon>
      </button>
   </div>
</div>